var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 132.41,
    style: {
      fill: "#73AF00"
    },
    width: 379.59,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F5F5F5"
    },
    width: 132.41,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M420.635,306.14c-44.151,39.331-111.736,35.288-150.988-8.94   c-39.176-44.147-35.21-111.929,8.938-151.257c0.064-0.057,0.129-0.114,0.193-0.171c1.043-0.918,0.035-2.583-1.26-2.079   c-43.539,16.955-74.408,59.305-74.408,108.891c0,64.591,52.233,116.903,116.67,116.903c44.575,0,83.204-25.081,102.827-61.901   c0.655-1.229-0.88-2.424-1.918-1.496C420.672,306.107,420.653,306.123,420.635,306.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M363.844,165.321l15.342,17.213l21.253-8.944c2.752-1.158,5.394,1.853,3.888,4.431l-11.63,19.911   l15.074,17.449c1.952,2.259-0.096,5.702-3.012,5.067l-22.53-4.908l-11.937,19.728c-1.545,2.554-5.453,1.671-5.75-1.299   l-2.295-22.944l-22.451-5.256c-2.907-0.681-3.274-4.669-0.541-5.87l21.112-9.272l-1.939-22.977   C358.178,164.674,361.858,163.092,363.844,165.321z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPk);
export default __webpack_public_path__ + "static/media/pk.b0729a60e9c21abf7b68c99e53c0a44e.svg";
export { ForwardRef as ReactComponent };